const backendDomin = process.env.REACT_APP_API_URL;
// const backendDomin = process.env.REACT_APP_LOCALHOST_URI;

// const backendDomin = `http://localhost:5000`

const SummaryApi = {
    // --- Existing User & Portfolio APIs ---
    userRegister: {
        url: `${backendDomin}/api/register`,
        method: "post"
    },
    signIn: {
        url: `${backendDomin}/api/login`,
        method: "post"
    },
    umedwarLogin: {
        url: `${backendDomin}/api/login-umedwar`,
        method: "post"
    },
    createPortfolioItem: {
        url: `${backendDomin}/api/createPortfolioItem`,
        method: "post"
    },
    getPortfolioItem: {
        url: `${backendDomin}/api/getPortfolioItem`,
        method: "get"
    },
    getCategories: {
        url: `${backendDomin}/api/getCategories`,
        method: "get"
    },

    //project managemnt endpoints
    addProject:{
        url:`${backendDomin}/api/addProject`,
        method:"POST"
    },
    getProjects:{
        url:`${backendDomin}/api/getProjects`,
        method:"GET"
    },
    updateProject: (id) =>({
        url:`${backendDomin}/api/updateProject/${id}`, //req.params
        method:"PUT"
    }),
    deleteProject: (projectId) => ({
        url:`${backendDomin}/api/deleteProject/${projectId}`,
        method:"DELETE"
    }),
    pinProject: (projectId) => ({
        url:`${backendDomin}/api/pinProject/${projectId}`,
        method:"PATCH"
    }),

    staff: {
    getAll: { url: `${backendDomin}/api/staff`, method: "get" },
    create: { url: `${backendDomin}/api/staff/create`, method: "post" },
    update: (id) => ({ url: `${backendDomin}/api/staff/${id}`, method: "put" }),
    delete: (id) => ({ url: `${backendDomin}/api/staff/${id}`, method: "delete" }),
  },

  leave: {
    getAll: { url: `${backendDomin}/api/leave`, method: "get" },
    create: { url: `${backendDomin}/api/leave/create`, method: "post" },
    update: (id) => ({ url: `${backendDomin}/api/leave/${id}`, method: "put" }),
    delete: (id) => ({ url: `${backendDomin}/api/leave/${id}`, method: "delete" }),
  },

  getSalaries: {
    url: `${backendDomin}/api/salary`,
    method: "get",
  },
  createSalary: {
    url: `${backendDomin}/api/salary/create`,
    method: "post",
  },
  updateSalary: (id) => ({
    url: `${backendDomin}/api/salary/${id}`,
    method: "put",
  }),
  deleteSalary: (id) => ({
    url: `${backendDomin}/api/salary/${id}`,
    method: "delete",
  }),

  bankAccount: {
    getAll: { url: `${backendDomin}/api/bank-accounts`, method: "get" },
    getTransactions: (id, query = "") => ({
      url: `${backendDomin}/api/bank-accounts/${id}/transactions${query ? `?${query}` : ""}`,
      method: "get",
    }),
    addMoney: (id) => ({
      url: `${backendDomin}/api/bank-accounts/${id}/add-money`,
      method: "post",
    }),
    spendMoney: (id) => ({
      url: `${backendDomin}/api/bank-accounts/${id}/spend-money`,
      method: "post",
    }),

    create: { url: `${backendDomin}/api/bank-accounts`, method: "post" },
    update: (id) => ({
      url: `${backendDomin}/api/bank-accounts/${id}`,
      method: "put",
    }),
  },

  schools: {
  getAll: { url: `${backendDomin}/api/schools`, method: "get" },
  create: { url: `${backendDomin}/api/schools`, method: "post" },
  update: (id) => ({ url: `${backendDomin}/api/schools/${id}`, method: "put" }),
  delete: (id) => ({ url: `${backendDomin}/api/schools/${id}`, method: "delete" }),
},

schoolTransactions: {
  getAll: { url: `${backendDomin}/api/school-transactions`, method: "get" },
  create: { url: `${backendDomin}/api/school-transactions`, method: "post" },
  update: (id) => ({ url: `${backendDomin}/api/school-transactions/${id}`, method: "put" }),
  delete: (id) => ({ url: `${backendDomin}/api/school-transactions/${id}`, method: "delete" }),
},


  idcards: {
    getAll: { url: `${backendDomin}/api/idcards`, method: "get" },
    create: { url: `${backendDomin}/api/idcards`, method: "post" },
    update: (id) => ({ url: `${backendDomin}/api/idcards/${id}`, method: "put" }),
    delete: (id) => ({ url: `${backendDomin}/api/idcards/${id}`, method: "delete" }),
  },

  idTransactions: {
  getAll: { url: `${backendDomin}/api/id-transactions`, method: "get" },
  create: { url: `${backendDomin}/api/id-transactions`, method: "post" },
  update: (id) => ({ url: `${backendDomin}/api/id-transactions/${id}`, method: "put" }),
  delete: (id) => ({ url: `${backendDomin}/api/id-transactions/${id}`, method: "delete" }),
},

stationaries: {
    getAll: { url: `${backendDomin}/api/stationaries`, method: "get" },
    create: { url: `${backendDomin}/api/stationaries`, method: "post" },
    update: (id) => ({ url: `${backendDomin}/api/stationaries/${id}`, method: "put" }),
    delete: (id) => ({ url: `${backendDomin}/api/stationaries/${id}`, method: "delete" }),
  },

  stationaryTransactions: {
    getAll: { url: `${backendDomin}/api/stationary-transactions`, method: "get" },
    create: { url: `${backendDomin}/api/stationary-transactions`, method: "post" },
    getByStationary: (id) => ({
      url: `${backendDomin}/api/stationary-transactions/stationary/${id}`,
      method: "get",
    }),
    update: (id) => ({
      url: `${backendDomin}/api/stationary-transactions/${id}`,
      method: "put",
    }),
    delete: (id) => ({
      url: `${backendDomin}/api/stationary-transactions/${id}`,
      method: "delete",
    }),
  },
  
    // --- Job Opening API Endpoints ---

    createJobOpening: {
        url: `${backendDomin}/api/job-openings`,
        method: "post"
    },
    getAllJobOpenings: {
        url: `${backendDomin}/api/job-openings`,
        method: "get"
    },
    getActiveJobOpenings: {
        url: `${backendDomin}/api/job-openings/active`,
        method: "get"
    },
    getJobOpeningsByDepartment: {
        url: `${backendDomin}/api/job-openings/department`,
        method: "get"
    },
    getJobOpeningById: {
        url: `${backendDomin}/api/job-openings`,
        method: "get"
    },
    updateJobOpening: {
        url: `${backendDomin}/api/job-openings`,
        method: "put"
    },
    deleteJobOpening: {
        url: `${backendDomin}/api/job-openings`,
        method: "delete"
    },
    toggleJobOpeningStatus: {
        url: `${backendDomin}/api/job-openings/toggle-status`,
        method: "put"
    },
    createApplication: {
        url: `${backendDomin}/api/applications`,
        method: "post"
    },
    getAllApplications: {
        url: `${backendDomin}/api/applications`,
        method: "get"
    },
    getApplicationsByJobId: {
        url: `${backendDomin}/api/applications/by-job`,
        method: "get"
    },
    getApplicationById: {
        
        url: `${backendDomin}/api/applications`,
        method: "get"
    },
    updateApplication: {
      
        url: `${backendDomin}/api/applications`,
        method: "put"
    },
    deleteApplication: {
        url: `${backendDomin}/api/applications`,
        method: "delete"
    },

    // election related
    CreatedUmedwar: {
        url: `${backendDomin}/api/create-umedwar`,
        method: "post"
    },
     GetUmedwar: {
        url: `${backendDomin}/api/umedwar-list`,
        method: "post"
    },
    CreatedSubUmedwar: {
        url: `${backendDomin}/api/create-subumedwar`,
        method: "post"
    },
     GetSubUmedwar: {
        url: `${backendDomin}/api/subumedwar-list`,
        method: "post"
    },
    UpdateUmedwar: {
        url: `${backendDomin}/api/update-umedwar`,
        method: "put"
    },
    DeleteUmedwar: {
        url: `${backendDomin}/api/delete-umedwar`,
        method: "delete"
    },
      UpdateSubUmedwar: {
        url: `${backendDomin}/api/update-subumedwar`,
        method: "put"
    },
    DeleteSubUmedwar: {
        url: `${backendDomin}/api/delete-subumedwar`,
        method: "delete"
    },

     CreateMatdar: {
        url: `${backendDomin}/api/create-matdar`,
        method: "post"
    },
     GetMatdar: {
        url: `${backendDomin}/api/matdar-list`,
        method: "post"
    },
    UpdateMatdar: {
        url: `${backendDomin}/api/matdar-update`,
        method: "put"
    },
    DeleteMatdar: {
        url: `${backendDomin}/api/matdar-delete`,
        method: "delete"
    },
     UpdateMatdarDetails: {
        url: `${backendDomin}/api/update-voter-details`,
        method: "put"
    },
    UploadExcell: {
        url: `${backendDomin}/api/matadar/upload-excel`,
        method: "post"
    },
    VoterMark: {
        url: `${backendDomin}/api/voter-mark`,
        method: "post"
    },
    GetVoterMark: {
        url: `${backendDomin}/api/get-votermark`,
        method: "post"
    },
     VoterStatusMark: {
        url: `${backendDomin}/api/voter-status-mark`,
        method: "post"
    },
    GetVoterStatusMark: {
        url: `${backendDomin}/api/get-voterstatusmark`,
        method: "post"
    },
}

export default SummaryApi;